module.exports = __webpack_public_path__ + "img/diplome-de-fin-detudes.fa53c21f.png";